import React, { useCallback, useEffect, useMemo } from 'react';
import useLayoutContext from '@hooks/useLayoutContext';
import Welcome from '@pages/PreAuthentication/components/Welcome';
import { FCWithChildren } from '@types';
import { useLocation, useParams } from 'react-router-dom';

type PreAuthenticationProps = {
  location?: {
    state: {
      isUserCreated: boolean;
      preWiredKey?: string;
    };
  };
};

const CaptivePortalSplash: FCWithChildren<PreAuthenticationProps> = () => {
  const location = useLocation();
  const { setIsCaptivePortal } = useLayoutContext();
  const queryParams = new URLSearchParams(location.search);
  const mac = queryParams.get('client_mac');
  const baseGrantUrl = queryParams.get('base_grant_url');

  useEffect(() => {
    setIsCaptivePortal(true);
    if (mac) {
      sessionStorage.setItem(
        'mac',
        mac.match(/\w{2}%3A\w{2}%3A\w{2}%3A\w{2}%3A\w{2}%3A\w{2}/)
          ? decodeURIComponent(mac.toUpperCase())
          : mac.toUpperCase(),
      );
    }

    sessionStorage.setItem('baseGrantUrl', baseGrantUrl || '');
    sessionStorage.setItem('userContinueUrl', `${window.location.origin}/captive-portal/continue`);
  }, []);

  const { welcomeMessage } = useLayoutContext();

  return <Welcome welcome={welcomeMessage || ''} bgImg={''} />;
};

export default CaptivePortalSplash;
